import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const ChoseOptionContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChoseOptionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
`;

export const ChoseOptionIcon = styled.div`
  width: 67px;
  height: 67px;
  background: ${colors.bgTertiary};
  border-radius: 16px;
  box-shadow: 0px 5px 10px ${colors.bgTertiaryShadow};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChoseOptionParapraph = styled.p`
  font-size: 16px;
  line-height: 23px;
  margin-top: 30px;
  color: ${colors.textPrimary};
  text-align: center;
`;

export const ChoseOptionFooter = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: center;

  button:first-child {
    margin-right: 20px;
  }
`;

export const ChoseOptionSelect = styled.div`

`;

export const ChoseOptionRadioContainer = styled.div`
  border-radius: 8px;
  padding: 17px;
  align-items: center;
  display: flex;
  
  &:first-child {
    margin-top: 20px;
  }
`;

export const ChoseOptionRadioField = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 14px;
  border: 1.5px solid ${colors.grayLight};
  background: ${prop => prop.checked ? colors.textHyperlink : colors.white};
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ChoseOptionRadioLabel = styled.h6`
  color: ${colors.textPrimary};
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
`;
